import type { FC } from 'react'
import { useEffect } from 'react'

import {
  AdjustmentMenu,
  AlgorithmMenu,
  GeometryMenu,
  MapMenu,
  SelectItemMenu,
} from './MapBuildingRightMenu'
import type { ModalBuildingRightMenuProps } from './types'

export const ModalBuildingRightMenu: FC<ModalBuildingRightMenuProps> = ({
  activeStep,
  methodValue,
  choiceValue,
  faultsFolderValue,
  onFaultsFolderUpdate,
  formData,
  setMethodValue,
  setChoiceValue,
  updateSourcesData,
  updateGeometryData,
  updateKernelData,
  updateTargetData,
  updateKrigingData,
  addedSelectItemList,
  updateSelectItemList,
  updateFaultsData,
  updateSequentialConvergenceData,
  updateMinimalCurvatureData,
  updateMovingAverageData,
}) => {
  useEffect(() => {
    updateTargetData(() => addedSelectItemList[0]?.value?.entityName ?? '')
  }, [addedSelectItemList[0]])

  switch (activeStep) {
    case 'object':
      return (
        <SelectItemMenu
          formData={formData}
          updateSourcesData={updateSourcesData}
          addedSelectItemList={addedSelectItemList}
          updateSelectItemList={updateSelectItemList}
        />
      )
    case 'geometry':
      return (
        <GeometryMenu
          choiceValue={choiceValue}
          formData={formData.buildInfo.geometry}
          setChoiceValue={setChoiceValue}
          updateGeometryData={updateGeometryData}
        />
      )
    case 'algorithms':
      return (
        <AlgorithmMenu
          methodValue={methodValue}
          formData={formData}
          setMethodValue={setMethodValue}
          updateKernelData={updateKernelData}
          updateKrigingData={updateKrigingData}
          updateSequentialConvergenceData={updateSequentialConvergenceData}
          updateMinimalCurvatureData={updateMinimalCurvatureData}
          updateMovingAverageData={updateMovingAverageData}
        />
      )
    case 'correction':
      return (
        <AdjustmentMenu
          updateFaultsData={updateFaultsData}
          faultsFolderValue={faultsFolderValue}
          onFaultsFolderUpdate={onFaultsFolderUpdate}
        />
      )
    case 'map':
      return <MapMenu mapName={formData.buildInfo.name} updateTargetData={updateTargetData} />
    default:
      return null
  }
}
